import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import type WorkSchedule from 'modules/work_schedules/store/models/Schedule'

interface Props {
  onSubmit: () => void
  disabled: boolean
  onConfirm: () => void
  onClose: () => void
  workSchedule: WorkSchedule
  canReassignAll: boolean
  isPeriod?: boolean
  canAssignEmployees: boolean
}

const WarningModal = ({
  onSubmit,
  disabled,
  onConfirm,
  onClose,
  workSchedule,
  canReassignAll,
  isPeriod,
  canAssignEmployees,
}: Props) => {
  const noOfEmployees = workSchedule.employeeIds.length

  const count = {
    count: noOfEmployees,
  }

  const payload = {
    count: noOfEmployees,
    date: dateBackendDateTimeToUI(workSchedule.attributes.created_at),
  }

  const noPermissions = !canAssignEmployees

  const title =
    noPermissions || !canReassignAll
      ? i18n.t('settings.work_schedule.settings_tab.edit_modal.not_allowed_title')
      : !isPeriod
        ? i18n.t('settings.work_schedule.settings_tab.edit_modal.title')
        : i18n.t('settings.work_schedule.settings_tab.edit_modal.edit_period')

  const description = noOfEmployees
    ? noPermissions
      ? i18n.tp('settings.work_schedule.settings_tab.edit_modal.description_no_permissions', count) // No permissions
      : canReassignAll
        ? i18n.tp('settings.work_schedule.settings_tab.edit_modal.description', payload) // Can edit
        : i18n.tp('settings.work_schedule.settings_tab.edit_modal.description_mixed', count) // Mixed teams
    : i18n.t('settings.work_schedule.settings_tab.edit_modal.description.zero') // No employees

  const footer =
    noPermissions || !canReassignAll ? (
      <Button type="primary" onClick={onClose}>
        {i18n.t('settings.work_schedule.settings_tab.edit_modal.not_allowed_submit')}
      </Button>
    ) : (
      <>
        <Button type="secondary" onClick={onClose}>
          {i18n.t('settings.work_schedule.cancel')}
        </Button>
        <Button onClick={onSubmit} disabled={disabled}>
          {i18n.t('settings.work_schedule.settings_tab.edit_modal.submit')}
        </Button>
      </>
    )

  return (
    <Modal
      illustration="alert"
      title={title}
      description={description}
      onClose={onClose}
      onSubmit={onConfirm}
      footer={footer}
    />
  )
}

export default observer(WarningModal)
